"use client";

import { useSessionStorage } from "@/components/hooks/use-session-storage";
import { logout as logoutAction } from "@/server/actions/common/logout/logout";
import { useCallback } from "react";

/**
 * ログアウト処理とsessionStorageのクリアを統合したフック
 */
export function useLogoutWithCleanup() {
  const { clearAll } = useSessionStorage();

  const logout = useCallback(async () => {
    await logoutAction();
    // ログアウト後にセッションストレージをクリア
    clearAll();
  }, [clearAll]);

  return { logout };
}
